<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <div class="search-header-box">
                <div class="search-icon" @click="$emit('modal-close')">
                  <img :src="require('@/assets/back-arrow-icon.svg')"/>
                </div>
                <input v-model="searchKeywordStrInput" class="search-input" placeholder="대화 내용 검색"
                       @keyup.enter="onEnter"/>
              </div>
            </slot>
          </div>
          <div class="vac-card-window" >
            <div class="vac-chat-container">
              <rooms-list
                :current-user-id="currentUserId"
                :rooms="formatRoomsInfoFn"
                :loading-rooms="loadingRoomsCasted"
                :rooms-loaded="roomsLoadedCasted"
                :room="room"
                :room-actions="roomActionsCasted"
                :text-messages="textMessages"
                :show-search="showSearchCasted"
                :show-add-room="showAddRoomCasted"
                :show-rooms-list="showRoomsList && roomsListOpenedCasted"
                :text-formatting="textFormattingCasted"
                :link-options="linkOptionsCasted"
                :is-mobile="isMobile"
                :scroll-distance="scrollDistance"
                @loading-more-rooms="loadingMoreRooms = $event"
              >
                <template v-for="el in slots" #[el.slot]="data">
                  <slot :name="el.slot" v-bind="data"/>
                </template>
              </rooms-list>
            </div>
          </div>
          <div class="modal-footer">
            <slot name="footer"/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

// import { RoomMessage, Loader } from 'vue-advanced-chat'

import { parseTimestamp, formatTimestamp } from '@/utils/dates'

import * as mongoService from '@/database/mongo'
import {
  Timestamp
} from 'firebase/firestore'

import { getI18NFn } from '@/utils/string'

import Loader from '/components/Loader/Loader'
import RoomsList from '/lib/RoomsList/RoomsList'
import RoomMessage from '../lib/Room/RoomMessage/RoomMessage.vue'

// window.appVm.$root.$toast.info('공지사항!!!!!!!!!!!!!!', {duration:5000});

// import { register } from './../../dist/vue-advanced-chat.es.js'
// import { register } from './../../src/lib/index.js'

export default {
  components: {
    RoomMessage,
    Loader,
    RoomsList
  },
  props: {
    currentUserId: { type: String, required: true },

    height: { type: String, default: '600px' },
    theme: { type: String, default: 'light' },
    styles: { type: [Object, String], default: () => ({}) },
    responsiveBreakpoint: { type: Number, default: 900 },
    singleRoom: { type: [Boolean, String], default: false },
    roomsListOpened: { type: [Boolean, String], default: true },
    textMessages: { type: [Object, String], default: () => ({}) },
    currentUserId: { type: String, default: '' },
    rooms: { type: [Array, String], default: () => [] },
    roomsOrder: { type: String, default: 'desc' },
    loadingRooms: { type: [Boolean, String], default: false },
    roomsLoaded: { type: [Boolean, String], default: false },
    roomId: { type: String, default: null },
    loadFirstRoom: { type: [Boolean, String], default: true },
    messages: { type: [Array, String], default: () => [] },
    messagesLoaded: { type: [Boolean, String], default: false },
    roomActions: { type: [Array, String], default: () => [] },
    menuActions: { type: [Array, String], default: () => [] },
    messageActions: {
      type: [Array, String],
      default: () => [
        { name: 'replyMessage', title: 'Reply' },
        { name: 'editMessage', title: 'Edit Message', onlyMe: true },
        { name: 'deleteMessage', title: 'Delete Message', onlyMe: true },
        { name: 'selectMessages', title: 'Select' }
      ]
    },
    messageSelectionActions: { type: [Array, String], default: () => [] },
    autoScroll: {
      type: [Object, String],
      default: () => {
        return {
          send: {
            new: true,
            newAfterScrollUp: true
          },
          receive: {
            new: true,
            newAfterScrollUp: false
          }
        }
      }
    },
    showSearch: { type: [Boolean, String], default: true },
    showAddRoom: { type: [Boolean, String], default: true },
    showSendIcon: { type: [Boolean, String], default: true },
    showFiles: { type: [Boolean, String], default: true },
    showAudio: { type: [Boolean, String], default: true },
    audioBitRate: { type: Number, default: 128 },
    audioSampleRate: { type: Number, default: 44100 },
    showEmojis: { type: [Boolean, String], default: true },
    showReactionEmojis: { type: [Boolean, String], default: true },
    showNewMessagesDivider: { type: [Boolean, String], default: true },
    showFooter: { type: [Boolean, String], default: true },
    textFormatting: {
      type: [Object, String],
      default: () => ({
        disabled: false,
        italic: '_',
        bold: '*',
        strike: '~',
        underline: '°',
        multilineCode: '```',
        inlineCode: '`'
      })
    },
    linkOptions: {
      type: [Object, String],
      default: () => ({ disabled: false, target: '_blank', rel: null })
    },
    roomInfoEnabled: { type: [Boolean, String], default: false },
    textareaActionEnabled: { type: [Boolean, String], default: false },
    textareaAutoFocus: { type: [Boolean, String], default: true },
    userTagsEnabled: { type: [Boolean, String], default: true },
    emojisSuggestionEnabled: { type: [Boolean, String], default: true },
    roomMessage: { type: String, default: '' },
    scrollDistance: { type: Number, default: 60 },
    acceptedFiles: { type: String, default: '*' },
    templatesText: { type: [Array, String], default: () => [] },
    mediaPreviewEnabled: { type: [Boolean, String], default: true },
    usernameOptions: {
      type: [Object, String],
      default: () => ({ minUsers: 3, currentUser: false })
    }
  },
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      showModal: false,
      orderedRooms: [
        {
          'users': [
            {
              '_id': '63c66bbf09bcc97b98883571',
              'username': '스윙투앱',
              'avatar': '/public/user_profile/3683285/20201502.png',
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 253870,
              'userStringId': 'sdh806@swing2app.com',
              'createdAt': '2023-01-17T09:34:55.166Z',
              'updatedAt': '2025-01-07T10:10:59.597Z',
              '__v': 0
            },
            {
              '_id': '6735bbd382b3e74cde125704',
              'username': 'sdh',
              'avatar': '/public/user_profile/13702396/20252807.png',
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 781998,
              'userStringId': '01033108411',
              'createdAt': '2024-11-14T08:58:59.569Z',
              'updatedAt': '2025-01-07T10:10:51.045Z',
              '__v': 0
            }
          ],
          'typingUsers': [],
          'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
          'lastUpdated': '2025-01-07T08:53:30.837Z',
          'roomType': 'USER_CHAT',
          'swingRoomDbId': '253870_781998',
          'createdAt': '2024-11-14T08:58:59.606Z',
          'updatedAt': '2025-01-07T08:53:30.837Z',
          'lastMessage': {
            '_id': '677ceb8ab4347e81b064c763',
            'roomId': '6735bbd382b3e74cde12570b',
            'content': '44',
            'senderId': '63c66bbf09bcc97b98883571',
            'timestamp': '2025-01-07T08:53:30.834Z',
            'system': false,
            'seens': [],
            'files': [],
            'roomUsers': [
              '6735bbd382b3e74cde125704'
            ],
            'createdAt': '2025-01-07T08:53:30.834Z',
            'updatedAt': '2025-01-07T08:53:30.834Z',
            '__v': 0
          },
          'id': '6735bbd382b3e74cde12570b'
        },
        {
          'users': [
            {
              '_id': '63c66bbf09bcc97b98883571',
              'username': '스윙투앱',
              'avatar': '/public/user_profile/3683285/20201502.png',
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 253870,
              'userStringId': 'sdh806@swing2app.com',
              'createdAt': '2023-01-17T09:34:55.166Z',
              'updatedAt': '2025-01-07T10:10:59.597Z',
              '__v': 0
            },
            {
              '_id': '6777946c82b3e74cde17f14c',
              'username': '1',
              'avatar': null,
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 731430,
              'userStringId': '1',
              'createdAt': '2025-01-03T07:40:28.224Z',
              'updatedAt': '2025-01-03T07:40:28.255Z',
              '__v': 0
            }
          ],
          'typingUsers': [],
          'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
          'lastUpdated': '2025-01-07T08:47:03.847Z',
          'roomType': 'BOARD_CHAT',
          'swingRoomDbId': 'd7eae8c73bfd4f02aa17',
          'createdAt': '2025-01-03T06:04:19.672Z',
          'updatedAt': '2025-01-07T10:02:31.710Z',
          'roomName': '게시판_cht3',
          'lastMessage': {
            '_id': '677cea07b4347e81b064c648',
            'roomId': '67777de382b3e74cde17ee8e',
            'content': '8',
            'senderId': '63c66bbf09bcc97b98883571',
            'timestamp': '2025-01-07T08:47:03.845Z',
            'system': false,
            'seens': [],
            'files': [],
            'roomUsers': [
              '6777946c82b3e74cde17f14c'
            ],
            'createdAt': '2025-01-07T08:47:03.845Z',
            'updatedAt': '2025-01-07T08:47:03.845Z',
            '__v': 0
          },
          'id': '67777de382b3e74cde17ee8e'
        },
        {
          'users': [
            {
              '_id': '63c66bbf09bcc97b98883571',
              'username': '스윙투앱',
              'avatar': '/public/user_profile/3683285/20201502.png',
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 253870,
              'userStringId': 'sdh806@swing2app.com',
              'createdAt': '2023-01-17T09:34:55.166Z',
              'updatedAt': '2025-01-07T10:10:59.597Z',
              '__v': 0
            }
          ],
          'typingUsers': [],
          'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
          'lastUpdated': '2025-01-07T06:29:14.126Z',
          'roomType': 'BOARD_CHAT',
          'swingRoomDbId': '47958b8f00a9443f8b8d',
          'createdAt': '2023-01-17T09:37:11.270Z',
          'updatedAt': '2025-01-07T06:29:14.126Z',
          'roomName': 'chat',
          'lastMessage': {
            '_id': '677cc9bab4347e81b064c48b',
            'roomId': '63c66c4709bcc97b988835a4',
            'content': '게시판채팅',
            'senderId': '63c66bbf09bcc97b98883571',
            'timestamp': '2025-01-07T06:29:14.121Z',
            'system': false,
            'seens': [],
            'files': [],
            'roomUsers': null,
            'createdAt': '2025-01-07T06:29:14.122Z',
            'updatedAt': '2025-01-07T06:29:14.122Z',
            '__v': 0
          },
          'id': '63c66c4709bcc97b988835a4'
        },
        {
          'users': [
            {
              '_id': '63c66bbf09bcc97b98883571',
              'username': '스윙투앱',
              'avatar': '/public/user_profile/3683285/20201502.png',
              'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
              'userDbId': 253870,
              'userStringId': 'sdh806@swing2app.com',
              'createdAt': '2023-01-17T09:34:55.166Z',
              'updatedAt': '2025-01-07T10:10:59.597Z',
              '__v': 0
            }
          ],
          'typingUsers': [],
          'appId': '0ad9c730-0ea0-4aa3-83f4-2711a34d1137',
          'lastUpdated': '2025-01-03T05:39:34.286Z',
          'roomType': 'BOARD_CHAT',
          'swingRoomDbId': '3c6e7bf486664dd2bde4',
          'createdAt': '2025-01-03T05:39:28.663Z',
          'updatedAt': '2025-01-03T05:39:34.287Z',
          'roomName': 'chat_250103',
          'lastMessage': {
            '_id': '6777781682b3e74cde17ed53',
            'roomId': '6777781082b3e74cde17ed2b',
            'content': '2',
            'senderId': '63c66bbf09bcc97b98883571',
            'timestamp': '2025-01-03T05:39:34.284Z',
            'system': false,
            'seens': [],
            'files': [],
            'roomUsers': null,
            'createdAt': '2025-01-03T05:39:34.285Z',
            'updatedAt': '2025-01-03T05:39:34.285Z',
            '__v': 0
          },
          'id': '6777781082b3e74cde17ed2b'
        }
      ],
      slots: [],
      room: {},
      loadingMoreRooms: false,
      showRoomsList: true,
      isMobile: false,
      showMediaPreview: false,
      previewFile: {},
      allUserMap: {},


    }
  },
  computed: {
    cssVars() {
      const defaultStyles = defaultThemeStyles[this.theme]
      const customStyles = {}

      Object.keys(defaultStyles).map(key => {
        customStyles[key] = {
          ...defaultStyles[key],
          ...(this.stylesCasted[key] || {})
        }
      })

      return cssThemeVars(customStyles)
    },
    singleRoomCasted() {
      return this.castBoolean(this.singleRoom)
    },
    roomsListOpenedCasted() {
      return this.castBoolean(this.roomsListOpened)
    },
    loadingRoomsCasted() {
      return this.castBoolean(this.loadingRooms)
    },
    roomsLoadedCasted() {
      return this.castBoolean(this.roomsLoaded)
    },
    loadFirstRoomCasted() {
      return this.castBoolean(this.loadFirstRoom)
    },
    messagesLoadedCasted() {
      return this.castBoolean(this.messagesLoaded)
    },
    showSearchCasted() {
      return this.castBoolean(this.showSearch)
    },
    showAddRoomCasted() {
      return this.castBoolean(this.showAddRoom)
    },
    showSendIconCasted() {
      return this.castBoolean(this.showSendIcon)
    },
    showFilesCasted() {
      return this.castBoolean(this.showFiles)
    },
    showAudioCasted() {
      return this.castBoolean(this.showAudio)
    },
    showEmojisCasted() {
      return this.castBoolean(this.showEmojis)
    },
    showReactionEmojisCasted() {
      return this.castBoolean(this.showReactionEmojis)
    },
    showNewMessagesDividerCasted() {
      return this.castBoolean(this.showNewMessagesDivider)
    },
    showFooterCasted() {
      return this.castBoolean(this.showFooter)
    },
    roomInfoEnabledCasted() {
      return this.castBoolean(this.roomInfoEnabled)
    },
    textareaActionEnabledCasted() {
      return this.castBoolean(this.textareaActionEnabled)
    },
    textareaAutoFocusCasted() {
      return this.castBoolean(this.textareaAutoFocus)
    },
    userTagsEnabledCasted() {
      return this.castBoolean(this.userTagsEnabled)
    },
    emojisSuggestionEnabledCasted() {
      return this.castBoolean(this.emojisSuggestionEnabled)
    },
    mediaPreviewEnabledCasted() {
      return this.castBoolean(this.mediaPreviewEnabled)
    },
    roomsCasted() {
      return this.castArray(this.rooms)
    },
    messagesCasted() {
      return this.castArray(this.messages)
    },
    roomActionsCasted() {
      return this.castArray(this.roomActions)
    },
    menuActionsCasted() {
      return this.castArray(this.menuActions)
    },
    messageActionsCasted() {
      return this.castArray(this.messageActions)
    },
    messageSelectionActionsCasted() {
      return this.castArray(this.messageSelectionActions)
    },
    templatesTextCasted() {
      return this.castArray(this.templatesText)
    },
    stylesCasted() {
      return this.castObject(this.styles)
    },
    textMessagesCasted() {
      return this.castObject(this.textMessages)
    },
    autoScrollCasted() {
      return this.castObject(this.autoScroll)
    },
    textFormattingCasted() {
      return this.castObject(this.textFormatting)
    },
    linkOptionsCasted() {
      return this.castObject(this.linkOptions)
    },
    usernameOptionsCasted() {
      return this.castObject(this.usernameOptions)
    },

    formatRoomsInfoFn() {

      const roomList = {}
      this.orderedRooms.forEach(room => {
        roomList[room.id] = { ...room }

        // eslint-disable-next-line camelcase
        room.users.forEach((lp_userInfo) => {
          // eslint-disable-next-line camelcase
          this.allUserMap[lp_userInfo._id] = lp_userInfo
          //   const foundUser = this.allUsers.find(user => user?._id === userId)
          //   if (foundUser) roomList[room.id].users.push(foundUser)
        })
      })
      const formattedRooms = []

      Object.keys(roomList).forEach(key => {
        const room = roomList[key]

        const roomContacts = room.users.filter(
          user => user._id !== this.currentUserId
        )

        room.roomName = (room.roomName) ? room.roomName
          : (roomContacts.map(user => user.username).join(', ') || 'Myself')

        let userImgUrl = (roomContacts && roomContacts[0] && roomContacts[0].avatar) ? roomContacts[0].avatar : null
        // eslint-disable-next-line eqeqeq
        if (userImgUrl && (userImgUrl.indexOf('http://') == -1 && userImgUrl.indexOf('https://') == -1)) {
          userImgUrl = 'https://ncdn2.swing2app.co.kr' + userImgUrl
        }

        const roomAvatar =
          roomContacts.length === 1 && userImgUrl
            ? userImgUrl
            : require('@/assets/user.png')

        const dateTimestampOb = Timestamp.fromDate(new Date(room.lastUpdated))

        let lastMessage = {
          content: '',
          timestamp: formatTimestamp(
            new Date(dateTimestampOb.seconds),
            dateTimestampOb
          )
        }


        formattedRooms.push({
          ...room,
          roomId: key,
          avatar: roomAvatar,
          index: dateTimestampOb.seconds,
          // index: new Date(room.lastUpdated).getTime(),
          // lastMessage: {
          //   content: '',
          //   timestamp: formatTimestamp(
          //     new Date(dateTimestampOb.seconds),
          //     dateTimestampOb
          //   )
          //   // timestamp: new Date(room.lastUpdated)
          // }
          lastMessage: lastMessage
        })
      })
      return formattedRooms
    },
  },
  created() {
    // const thisOb = this
    // thisOb.allUserMap = window.getAllUserMapFn()
  },
  updated() {
  },
  mounted() {
    const thisOb = this
    thisOb.allUserMap = window.getAllUserMapFn()
  },

  methods: {
    castBoolean(val) {
      return val === 'true' || val === true
    },
    castArray(val) {
      return !val ? [] : Array.isArray(val) ? val : JSON.parse(val)
    },
    castObject(val) {
      return !val ? {} : typeof val === 'object' ? val : JSON.parse(val)
    },

  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  display: flex;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;

  display: flex;
  /*width: 100%;*/
  width: calc(100% - 20px);

  /*padding: 20px 30px 30px;*/
  padding: 10px;
}

.modal-container {
  /*width: 300px;*/
  margin: 0px auto;
  /*padding: 20px 30px;*/
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;

  width: 100%;
  height: 100%;

  position: relative;
  display: flex;
  flex-flow: column;

  .modal-header {
    position: absolute;
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    z-index: 10;

    .search-header-box {
      display: flex;
      width: 100%;
      padding: 0 20px 0 10px;
      gap: 3px;

      .search-icon {
        align-items: center;
        display: flex;
        padding: 0 10px;

        img {
          width: 20px;
        }
      }

      .search-input {
        background: #fff;
        border-radius: 0;
        border: 1px solid #dce1e4;
        box-shadow: none !important;
        font-size: 13px;
        padding: 6px 10px !important;
        -webkit-transition: all .2s ease-in-out;
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;

        display: block;
        width: 100%;
        height: 22px;

        line-height: 1.42857143;
        color: #555;
        flex: 1;
      }
    }
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin-top: 51px;
    /*margin: 20px 0;*/
    flex: 1;
    overflow-y: auto;
    background-color: #f8f9fa;

    padding: 10px 15px;
    overflow-x: hidden;
  }

  .modal-footer {
    /*width: 100%;*/
    border-top: 1px solid #5f5f5f;
    height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;

    .chat-move-btn-group-box {
      display: flex;
      align-items: center;
      gap: 5px;

      .chat-move-btn {
        padding: 5px;

      }
    }

    .search-idx-info-box {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
    }

  }

}

.modal-default-button {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  /*font-size: 14px;*/
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #adadad;
  border-radius: 4px;

  font-size: 13px;
  /*border-radius: 0;*/
  outline: 0 !important;
  height: 20px;
  line-height: 20px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

#pointEl {
  background-color: red;
}

</style>
